<template>
    <div class="proj-toolbox-area" v-if="device_relations != undefined">

        <b-row>

            <b-col :md="alignBlock">
                <h4 v-text="$t('n.device') + ' 期作關聯'"></h4>

                <b-row v-if="device_relations.cropperiods != undefined && device_relations.cropperiods.length > 0">
                    <b-col md=12>
                        <div class="list" v-for="(relation, idx_r) in device_relations.cropperiods" :key="idx_r">
                            {{ relation.name }} (ID={{ relation.id }})
                            <div v-if="relation.note">
                                <i class="icon-menu"></i>{{ $t('menu.admin_note') }}：{{ relation.note }}
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div v-else>
                    <NoData></NoData>
                </div>
            </b-col>

            <b-col :md="alignBlock">
                <h4 v-text="$t('n.device') + ' gateway 關聯'"></h4>

                <b-row v-if="device_relations.gateways != undefined && device_relations.gateways.length > 0">
                    <b-col md=12 v-for="(relation, idx_r) in device_relations.gateways" :key="idx_r">
                        <b-alert show variant="success">
                            {{ relation.hashid }} (ID={{ relation.gatewayid }})
                            <i class="fa fa-external-link-square block-text clickable" @click="goToPage('edit_gateway', { gatewayID: relation.hashid }, true)"></i>
                            <br>
                            {{ relation.nickname }}
                            <br>
                            <div class="list" v-if="relation.project_info">
                                <i class="fa fa-industry block-text"></i>綁定專案：{{ relation.project_info.name }} (ID={{ relation.project_info.id }})
                                <i class="fa fa-external-link-square block-text clickable" @click="goToPage('project', { projectID: relation.project_info.id }, true)"></i>
                                <div v-if="relation.project_info.note">
                                    <i class="icon-menu"></i>{{ $t('menu.admin_note') }}：{{ relation.project_info.note }}
                                </div>
                            </div>
                        </b-alert>
                    </b-col>
                </b-row>
                <div v-else>
                    <NoData></NoData>
                </div>
            </b-col>

        </b-row>

        
        
        
        
    </div>
</template>

<script>
import NoData from '@/views/components/NoData'

export default {
    props: {
        device_id: {
            type: String,
            required: true,
        },
        alignBlock: {
            type: [String,Number],
            default: 12,
        },
    },
    components: {
        NoData,
    },
    data () {
        return {
            device_relations: undefined,
        }
    },
    mounted ()
    {
        this.get_Relations()
    },
    computed: {

    },
    methods:
    {
        goToPage: function (type, params = {}, openNewTab = false)
        {
            let routeData = this.$config.getPagesURL( type, params )
            
            if (routeData != undefined)
            {
                if (openNewTab) {
                    let _url = this.$router.resolve( routeData )
                    window.open( _url.href, '_blank' );
                }
                else { this.$router.push( routeData ); }
            }
        },

        get_Relations ()
        {
            this.device_relations = undefined

            const options = {
                method:'GET',
                url: this.$config.getAPI_URL('Get_Device_Relations', { deviceID: this.device_id }),
            }
            this.$http(options)
                .then( res => {
                    
                    if ( res.data ) this.device_relations = res.data
                })
                .catch( err => {
                
                })
        },

    }
}
</script>

<style lang="scss" scoped>

.list
{
    display: inline-block;
    color: #2b3336;
    background-color: #79c9c9;
    padding: 3px 10px;
    border-radius: 5px;
    margin: 2px 15px 15px 0px;
}

</style>
